export const getters = {
	estate: state => state.estate,
	client: state => state.client,
  clients: state => state.clients,
  getClientById: state => id => state.clients.find(client => client.id === id)
}



// WEBPACK FOOTER //
// ./src/store/modules/Clients/getters.js